import { LEADS_EXPORT_SELECTION_TOP_N_VALUES } from "app/pages/sales-intelligence/sub-modules/company-search/constants/websites-table";
import createExportSelectionDropdown from "app/pages/sales-intelligence/sub-modules/company-search/models/table-actions-panel/export/factory";
import { LeadsType } from "app/pages/sales-intelligence/sub-modules/company-search/types/common";

const exportSelectionDropdown = createExportSelectionDropdown(
    {
        topNValues: LEADS_EXPORT_SELECTION_TOP_N_VALUES,
    },
    LeadsType.Websites,
);

export default exportSelectionDropdown;
